import { Component } from "react";
import { inject, observer } from "mobx-react";

// components
import applicationRouter from '~/hoc/applicationRouter';
import withLocalization from '~/hoc/withLocalization';
import GenericForm from '~/components/GenericForm/GenericForm';
import LoadingSpinner from '~/elements/LoadingSpinner';

// schema
import getSchema from '~/library/schemas/appVersions';

const appVersionUiSchema = {
    'ui:field': 'layout',
    'ui:layout:hideframe': true,
    'ui:layout': [
        {
            platform: { xs: 6, className: 'mb-2 mt-2' },
            version: { xs: 6, className: 'mb-2 mt-2' },
        },
        {
            force_update_required: { xs: 12, className: 'mb-2 mt-2' },
        },
        {
            title: { xs: 6, className: 'mb-2 mt-2' },
            message: { xs: 6, 'ui:widget': 'textarea', className: 'mb-2 mt-2' },
        }
    ],
    platform: {
        'ui:widget': 'SimpleSelectWidget',
        'ui:placeholder': 'Select Platform',
        'ui:options': [
            { label: 'iOS', value: 'ios' },
            { label: 'Android', value: 'android' },
            { label: 'Pad iOS', value: 'pad-ios' },
            { label: 'Pad Android', value: 'pad-android' }
        ]
    },
    force_update_required: {
        'ui:widget': 'CheckBoxWidget',
        'ui:options': {
            label: false
        }
    },
};

class AppVersionForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            schema: getSchema(props),
            formData: {
                platform: 'ios',
                version: '',
                force_update_required: false,
                title: '',
                message: ''
            }
        };
    }

    onSave = async (values) => {
        const { clientStore, commonStore, t } = this.props;
        this.setState({ loading: true });

        try {
            await clientStore.addAppVersion(values);
            commonStore.addNotification(t('Version added successfully'), null, 'success');
            this.getBack();
        } catch (error) {
            const errorMsg = error?.message || t('Something went wrong');
            commonStore.addNotification(errorMsg, null, 'error');
        } finally {
            this.setState({ loading: false });
        }
    }

    getBack = () => {
        this.props.router.navigate('/admin/app_versions');
    }

    validateForm(formData, errors) {
        const { t } = this.props;
        const versionRegex = /^\d+(\.\d+){1,2}$/;

        if (formData.version && !versionRegex.test(formData.version)) {
            errors.version.addError(t('Invalid format. Use 1.0.0'));
        }

        return errors;
    }

    render() {
        const { loading, formData, schema } = this.state;
        if (loading) return <LoadingSpinner />;

        return (
            <div className="primary-page">
                <GenericForm
                    entity={formData}
                    uiSchema={appVersionUiSchema}
                    schema={schema}
                    translationScope="forms.app_version"
                    onSave={this.onSave}
                    goBack={this.getBack}
                    listUrl="/admin/app_versions"
                    customvalidate={(formData, errors) => this.validateForm(formData, errors)}
                />
            </div>
        );
    }
}

export default inject('commonStore', 'clientStore')(applicationRouter(withLocalization(observer(AppVersionForm))));